module.exports = __webpack_public_path__ + "static/media/ImageWifi.1867b94e.png";